import { jsx as _jsx } from "react/jsx-runtime";
var PlaySquare = function PlaySquare(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 3C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3H4ZM10 9.04031V14.9597C10 15.3789 10.485 15.612 10.8123 15.3501L14.512 12.3904C14.7622 12.1903 14.7622 11.8097 14.512 11.6096L10.8123 8.64988C10.485 8.38797 10 8.62106 10 9.04031Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default PlaySquare;